var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _vm.templateSelected
          ? _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("e-sign-package.messages.optionallyAddDocs")) +
                  "\n    "
              ),
            ])
          : _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("e-sign-package.messages.letsStartBySelectingDocs")
                  ) +
                  ":\n    "
              ),
            ]),
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("v-client-table", {
            staticClass: "vue-custom-table no-pagination",
            attrs: {
              data: _vm.documentValues,
              columns: _vm.table.columns,
              options: _vm.table.options,
              name: "selectFilesTable",
            },
            scopedSlots: _vm._u([
              {
                key: "h__selected",
                fn: function () {
                  return [
                    _c("div", { staticClass: "form-group-checkbox" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pretty p-icon p-jelly p-smooth p-curve mr-0",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.allDocumentsMarked,
                                expression: "allDocumentsMarked",
                              },
                            ],
                            ref: "selectAll",
                            staticClass: "form-check-input",
                            attrs: {
                              id: "select-all",
                              type: "checkbox",
                              name: "select-all",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.allDocumentsMarked)
                                ? _vm._i(_vm.allDocumentsMarked, null) > -1
                                : _vm.allDocumentsMarked,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.allDocumentsMarked,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.allDocumentsMarked = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.allDocumentsMarked = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.allDocumentsMarked = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "state p-primary" }, [
                            _c("i", { staticClass: "icon fa fa-check" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "hidden-text",
                                attrs: { for: "select-all" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("global.actions.selectAll"))
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "selected",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "form-group-checkbox" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pretty p-icon p-jelly p-smooth p-curve mr-0",
                        },
                        [
                          _c("input", {
                            staticClass: "form-check-input",
                            attrs: {
                              id: "select-" + row.documentId,
                              type: "checkbox",
                            },
                            domProps: {
                              checked: _vm.selectedDocuments.includes(
                                row.documentId
                              ),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.handleSelectedChange(
                                  $event,
                                  row.documentId
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "state p-primary" }, [
                            _c("i", { staticClass: "icon fa fa-check" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "hidden-text",
                                attrs: { for: "select-" + row.documentId },
                              },
                              [_vm._v(_vm._s(_vm.$t("global.words.select")))]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "filename",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "h5",
                      {
                        staticClass:
                          "mb-0 font-sm text-light-gray bold d-inline",
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(row.fileName) + "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "documenttype",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "h5",
                      {
                        staticClass: "mb-0 font-sm text-primary bold d-inline",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.classificationType) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }